import React, { useState } from 'react'
import Quickstart from '@SiteContainers/Quickstart'

import './Onboarding.scss'

const Onboarding: React.FC = () => {
  const [hasJustStartedQuickstartProcessing, setHasJustStartedQuickstartProcessing] = useState(false)

  return (
    <div className="Onboarding">
      <Quickstart
        hasJustStartedQuickstartProcessing={hasJustStartedQuickstartProcessing}
        setHasJustStartedQuickstartProcessing={setHasJustStartedQuickstartProcessing}
      />
    </div>
  )
}

export default Onboarding
